import { message } from "antd";
import axiosInstance from "../axiosInstance";
import { PAGE_SIZE } from "../constants";

import {
	CREATE_SPIN_RATE_REQUEST,
	CREATE_SPIN_RATE_SUCCESS,
	CREATE_SPIN_RATE_FAIL,
	RESET_DELETE_SPIN_RATE,
	FETCH_SPIN_RATES_REQUEST,
	FETCH_SPIN_RATES_SUCCESS,
	FETCH_SPIN_RATES_FAIL,
	UPDATE_SPIN_RATE_REQUEST,
	UPDATE_SPIN_RATE_SUCCESS,
	UPDATE_SPIN_RATE_FAIL,
	DELETE_SPIN_RATE_REQUEST,
	DELETE_SPIN_RATE_SUCCESS,
	DELETE_SPIN_RATE_FAIL,
	FETCH_SPIN_RATE_REQUEST,
	FETCH_SPIN_RATE_SUCCESS,
	FETCH_SPIN_RATE_FAIL,
} from "../constants/spinTheWheelRate";

const createSpinRate = (values) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();
	dispatch({ type: CREATE_SPIN_RATE_REQUEST });
	try {
		const { data } = await axiosInstance.post("/admin/rates", values, {
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});
		message.success("Created.");
		dispatch(fetchSpinRates({ start: 0, count: PAGE_SIZE }));
		dispatch({
			type: CREATE_SPIN_RATE_SUCCESS,
			payload: data,
		});
	} catch (error) {
		const errorMessage = error.response.data.error;
		message.error(errorMessage);
		dispatch({ type: CREATE_SPIN_RATE_FAIL, payload: errorMessage });
	}
};

const fetchSpinRates = (params) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();

	dispatch({ type: FETCH_SPIN_RATES_REQUEST });
	try {
		const { data } = await axiosInstance.get("/admin/rates", {
			params,
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});

		dispatch({
			type: FETCH_SPIN_RATES_SUCCESS,
			payload: data,
		});
	} catch (error) {
		console.log("error: ", error);
		const errorMessage = error.response.data.error;
		dispatch({ type: FETCH_SPIN_RATES_FAIL, payload: errorMessage });
	}
};

const resetDeleteStatusSpinRate = () => async (dispatch) => {
	dispatch({ type: RESET_DELETE_SPIN_RATE });
};

const updateSpinRate = (id, values) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();
	dispatch({ type: UPDATE_SPIN_RATE_REQUEST });
	try {
		const { data } = await axiosInstance.patch(`/admin/rates/${id}`, values, {
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});

		message.success("Updated.");
		dispatch({
			type: UPDATE_SPIN_RATE_SUCCESS,
			payload: data,
		});
	} catch (error) {
		const errorMessage = error.response.data.error;
		message.error(errorMessage);
		dispatch({ type: UPDATE_SPIN_RATE_FAIL, payload: errorMessage });
	}
};

const deleteSpinRate = (id) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();
	dispatch({ type: DELETE_SPIN_RATE_REQUEST });
	try {
		const { data } = await axiosInstance.delete(`/admin/rates/${id}`, {
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});

		message.success("Deleted.");
		dispatch({
			type: DELETE_SPIN_RATE_SUCCESS,
			payload: data,
		});
	} catch (error) {
		const errorMessage = error.response.data.error;
		message.error(errorMessage);
		dispatch({ type: DELETE_SPIN_RATE_FAIL, payload: errorMessage });
	}
};

const fetchSpinRate = (id) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();
	dispatch({ type: FETCH_SPIN_RATE_REQUEST });

	try {
		const { data } = await axiosInstance.get(`/admin/rates/${id}`, {
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});

		dispatch({ type: FETCH_SPIN_RATE_SUCCESS, payload: data.data });
	} catch (error) {
		console.log("error: ", error);
		const errorMessage = error.response.data.error;
		message.error(errorMessage);
		dispatch({ type: FETCH_SPIN_RATE_FAIL, payload: errorMessage });
	}
};

export {
	createSpinRate,
	resetDeleteStatusSpinRate,
	fetchSpinRates,
	updateSpinRate,
	deleteSpinRate,
	fetchSpinRate,
};
